import { render, staticRenderFns } from "./OrderInfoTab.vue?vue&type=template&id=500b6367&scoped=true"
import script from "./OrderInfoTab.vue?vue&type=script&lang=ts"
export * from "./OrderInfoTab.vue?vue&type=script&lang=ts"
import style0 from "./OrderInfoTab.vue?vue&type=style&index=0&id=500b6367&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b6367",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500b6367')) {
      api.createRecord('500b6367', component.options)
    } else {
      api.reload('500b6367', component.options)
    }
    module.hot.accept("./OrderInfoTab.vue?vue&type=template&id=500b6367&scoped=true", function () {
      api.rerender('500b6367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/OrderInfoTab.vue"
export default component.exports